import { Box, Text } from "@chakra-ui/react";

export default function TextDisplay({ label, value }: { label: string; value?: string | null }) {
  return (
    <Box>
      <Text fontSize="sm" color="gray.500">{label}</Text>
      <Text fontSize="md" fontWeight="medium" color="gray.700">{value || "Não informado"}</Text>
    </Box>
  );
}